import { TagsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/tags/TagsServiceClientPb';
import {
  Tag,
  GetTagRequest,
  CreateTagRequest,
  CreateTagResponse,
  DeleteTagRequest,
  DeleteTagResponse,
  ListTagsRequest,
  ListTagsResponse,
  GetTagValuesRequest,
  GetTagValuesResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/tags/tags_pb';

export type TagsExportClasses = {
  TagsServiceClient: typeof TagsServiceClient;
  Tag: typeof Tag;
  GetTagRequest: typeof GetTagRequest;
  CreateTagRequest: typeof CreateTagRequest;
  CreateTagResponse: typeof CreateTagResponse;
  DeleteTagRequest: typeof DeleteTagRequest;
  DeleteTagResponse: typeof DeleteTagResponse;
  ListTagsRequest: typeof ListTagsRequest;
  ListTagsResponse: typeof ListTagsResponse;
  GetTagValuesRequest: typeof GetTagValuesRequest;
  GetTagValuesResponse: typeof GetTagValuesResponse;
};

export const tags: TagsExportClasses = {
  TagsServiceClient,
  Tag,
  GetTagRequest,
  CreateTagRequest,
  CreateTagResponse,
  DeleteTagRequest,
  DeleteTagResponse,
  ListTagsRequest,
  ListTagsResponse,
  GetTagValuesRequest,
  GetTagValuesResponse,
};
